import { motion } from "framer-motion";
import { Wallet, Swords, Trophy } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Wallet,
    title: "Buy ARC",
    body: "Acquire ARC during presale or from listed exchanges. Hold it in any EVM-compatible wallet.",
    color: "#39FF14",
    testid: "step-buy",
  },
  {
    n: "02",
    icon: Swords,
    title: "Enter PvP Tournaments",
    body: "Pay your entry fee in ARC, get bracketed against other real players, and compete.",
    color: "#00F0FF",
    testid: "step-enter",
  },
  {
    n: "03",
    icon: Trophy,
    title: "Win the Pool",
    body: "Beat the bracket and the pool pays out — minus a flat 8% commission (7% if you created it).",
    color: "#FF3B30",
    testid: "step-win",
  },
];

export default function HowItWorks() {
  return (
    <section className="relative py-24 sm:py-32" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#39FF14]">// the loop</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-2">How it works</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-8 relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-1/2 left-[16%] right-[16%] h-px bg-gradient-to-r from-[#39FF14] via-[#00F0FF] to-[#FF3B30] opacity-30" />

          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="relative glass p-7 sm:p-8 group"
              data-testid={s.testid}
            >
              <div className="flex items-start justify-between mb-6">
                <div
                  className="w-14 h-14 grid place-items-center clip-hex"
                  style={{ background: `${s.color}1A`, border: `1px solid ${s.color}55` }}
                >
                  <s.icon className="w-6 h-6" style={{ color: s.color }} />
                </div>
                <span className="font-display text-5xl font-black" style={{ color: s.color, opacity: 0.25 }}>
                  {s.n}
                </span>
              </div>
              <h3 className="font-display text-xl font-bold mb-3">{s.title}</h3>
              <p className="text-white/65 font-mono text-sm leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
